export enum SamplesPlans {
    all_access_annual_billed_monthly = 'all_access_annual_billed_monthly',
    all_access = 'all_access',
    samples_tier1 = 'samples_tier1',
    samples_tier2 = 'samples_tier2',
    samples_tier3 = 'samples_tier3',
    samples_pro = 'samples_pro',
    studio_pro = 'studio_pro',
}
